<div class="unexpected-error-container horizontal">
    <img src="assets/images/erro-500.png" alt="Erro inesperado" class="error-illustration large">
    <div class="unexpected-error-content">
      <h1>Ops! Algo inesperado aconteceu 😅</h1>
      <p>
        Pedimos desculpas pelo transtorno.<br>
        Nosso time já foi notificado e está trabalhando para resolver.<br>
        Por favor, tente novamente em alguns instantes.<br>
        <br>
        <strong>Obrigado pela compreensão!</strong>
      </p>
      <button routerLink="/" class="btn btn-primary">Voltar para o início</button>
    </div>
  </div>